import { useFormik } from "formik";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import axiosInstance from "../../../axiosInterceptor";
import { fetchAllData } from "../../../helper/ProductAttributeHandling";
import { layoutSchema } from "../../../Schema/Schema";
import FormFields from "./FormFields";
import CodeEditor from "../../../Components/CodeEditor";
import Select from "react-select";
import { SwitchToggle } from "../../../helper/ImageFormat";
const AddPageContent = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const editdata = location.state;
  const [categoryData, setCategoryData] = useState([]);
  const [menuData, setMenuData] = useState([]);
  const [btnLoading, setBtnLoading] = useState(false);
  const [showEditor, setShowEditor] = useState(false);
  useEffect(() => {
    fetchAllData("/category", setCategoryData);
    fetchAllData("/menu?params=all", setMenuData);
  }, []);

  useEffect(()=>{
    if(editdata?.id && editdata.data?.length === 0){
       setShowEditor(true)
    }
  },[editdata?.id])

  const initialValues = editdata?.id
    ? {
      title: editdata?.title || "",
      type: editdata?.type || "four banner",
      categoryId: editdata?.categoryId || null,
      data: editdata?.data || [],
      htmlContent: editdata?.htmlContent || "",
      fullScreen: editdata?.fullScreen || false,
      pageName: editdata?.pageName || "",
      isActive: editdata?.isActive ? true : false,
      position: editdata?.position || 0,
    }
    : {
      title: "",
      type: "four banner",
      categoryId: null,
      htmlContent: "",
      data: [],
      fullScreen: false,
      isActive: true,
      position: editdata?.position || 0,
      pageName: ""
    };

  const formik = useFormik({
    initialValues,
    validationSchema: layoutSchema,
    onSubmit: async (values, { setErrors }) => {
      if (values.type === "product" && !values.categoryId) {
        setErrors({ categoryId: "Category is required for Product type" });
        return;
      }

      setBtnLoading(true);
      try {
        const payload = { ...values };
        const response = editdata?.id
          ? await axiosInstance.put(`page-content/${editdata.id}`, payload)
          : await axiosInstance.post("page-content", payload);

        toast.success(response.data?.message);
        navigate("/page-content");
      } catch (error) {
       return error
      } finally {
        setBtnLoading(false);
      }
    },
  });

  const { errors, values, touched, handleChange, handleSubmit, setFieldValue } = formik;

  const handleAddItem = () => {
    setFieldValue("data", [...values.data, { image: "", link: "", buttonText: "" }]);
    setShowEditor(false)
  };

  const handleRemoveItem = (index) => {
    setFieldValue("data", values.data.filter((_, i) => i !== index));
  };

  const handleEditor = () => {
    setShowEditor(true);
    // setFieldValue("data", []);
  };

  const menuOptions = menuData.map((menu) => {
    if (menu.children && menu.children.length > 0) {
      return {
        label: menu.label,
        options: [
          { label: `${menu.label} (Parent)`, value: menu.url },
          ...menu.children.map((child) => ({
            label: `↳ ${child.label}`,
            value: child.url,
          })),
        ],
      };
    } else {
      return {
        label: menu.label,
        value: menu.url,
      };
    }
  });

  const allOptions = [
  { label: "Home", value: "home" },
  ...menuOptions,
];


  const selectedOption = allOptions
  .flatMap(option => option.options ? option.options : [option]) 
  .find(opt => opt.value === values.pageName) || null;
  return (
    <div className="content-wrapper">
      <div className="page-header mt-5 mx-4">
        <h3 className="page-title">{editdata?.id ? "Edit " : "Add "} Page Content</h3>
      </div>

      <div className="card">
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-sm-4">
                <label>Enter Title</label>
                <input
                  type="text"
                  name="title"
                  placeholder="Title"
                  className="form-control form-control-sm border border-dark"
                  onChange={handleChange}
                  value={values.title}
                />
                {touched.title && errors.title && <p className="text-danger">{errors.title}</p>}
              </div>




              <div className="col-sm-4">
                <label>Select Page</label>
                <Select
                  options={allOptions}
                    value={selectedOption}
                 onChange={(selected) => {
    setFieldValue("pageName", selected.value);
    setShowEditor(selected.value !== "home");
  }}
                  placeholder="Select page"
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      minHeight: 43,
                      border: '1px solid #343a40',
                      boxShadow: 'none',
                    }),
                    menu: (provided) => ({
                      ...provided,
                      maxHeight: 300,
                    }),
                  }}
                />
                {touched.pageName && errors.pageName && (
                  <p className="text-danger">{errors.pageName}</p>
                )}
              </div>



              <div className="col-sm-4">
                <label >Position</label>
                <input
                  type="number"
                  className="form-control form-control-sm border border-dark"
                  name="position"
                  value={values.position}
                  onChange={handleChange}
                />
              </div>



              {
                values.pageName === "home" && (
                  <div className="col-sm-6 mt-2">
                    <label>Select Layout Type</label>
                    <select
                      name="type"
                      className="form-control form-control-sm"
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      value={values.type}
                    >
                      <option value="" disabled>
                        Select type
                      </option>
                      <option value="product">Product (Category Wise)</option>
                      <option value="full slider">Full Screen Slider</option>
                      <option value="cards slider">Cards Slider</option>
                      <option value="slider 3d">3D Slider</option>
                      <option value="two banner">Two Banner</option>
                      <option value="three banner">Three Banner</option>
                      <option value="four banner">Four Banner</option>
                    </select>
                    {touched.type && errors.type && <p className="text-danger">{errors.type}</p>}
                  </div>

                )
              }



              {values.type === "product" && (
                <div className="col-sm-6 mt-2">
                  <label>Select Category</label>
                  <select
                    name="categoryId"
                    className="form-control form-control-sm"
                    onChange={handleChange}
                    value={values.categoryId || ""}
                  >
                    <option value="">Select Category</option>
                    {categoryData.map((cat) => (
                      <option key={cat.id} value={cat.id}>
                        {cat.name}
                      </option>
                    ))}
                  </select>
                  {errors.categoryId && <p className="text-danger mt-1">{errors.categoryId}</p>}
                </div>
              )}
            </div>

            {values.pageName === "home" && (
              <div className="row mt-4">
                <div className="col-12 d-flex flex-wrap align-items-center" style={{ gap: "15px" }}>
                  <button
                    type="button"
                    className="btn btn-primary btn-sm"
                    onClick={handleAddItem}
                  >
                    Add Item
                  </button>

                  <button
                    type="button"
                    className="btn btn-dark btn-sm"
                    onClick={handleEditor}
                  >
                    Editor
                  </button>


                  {
                    showEditor && (

                      <label className="col-form-label d-block ml-3">
                        <input
                          type="checkbox"
                          name="fullScreen"
                          className="form-check-input mt-0"
                          id="fullScreenCheckbox"
                          checked={values.fullScreen}
                          onChange={(e) => setFieldValue("fullScreen", e.target.checked)}
                        />{" "}
                        Full Screen
                      </label>
                    )
                  }



                </div>
              </div>

            )}
            {!showEditor && values.type && values.type !== "product" && (
              <>
                {values.data.length > 0 && (
                  <FormFields
                    cards={values.data}
                    setFieldValue={setFieldValue}
                    handleRemoveItem={handleRemoveItem}
                    fieldName="data"
                  />
                )}
              </>
            )}
            {showEditor && (
              <div className="mt-5">

                <CodeEditor
                  placeholder="Enter HTML content..."
                  value={values.htmlContent}
                  onChange={(val) => setFieldValue("htmlContent", val)}
                />
              </div>
            )}


            <div className="col-md-12 mt-4 p-0">
              <SwitchToggle
                checked={values.isActive}
                onChange={(val) => setFieldValue("isActive", val)}
              />
            </div>

            <div className="mt-4 d-flex justify-content-center" style={{ gap: "10px" }}>
               <button type="submit" className="btn btn-info d-flex align-items-center" disabled={btnLoading}>
                {btnLoading && (
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                )}
                {btnLoading ? "Adding..." : "Add"}
              </button>
              <button type="button" className="btn btn-danger" onClick={() => navigate("/page-content")}>
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddPageContent;
